module.exports = __webpack_public_path__ + "img/effect.21404bfe.png";